const ENVIRONMENTS = {
  'http://staging-api.viewlift.com': 'develop',
  'http://release-api.viewlift.com': 'release',
  'https://prod-api.viewlift.com': 'production'
}

export default () => ENVIRONMENTS[window.settings.apiBaseUrl];
